import { useEffect, useState } from "react";
import {
  Segment,
  Input,
  Icon,
  Grid,
  Loader,
  Button,
  Modal, Popup,
} from "semantic-ui-react";
import {
  getBeneficiarios,
  deleteBeneficiario,
  addExcelBeneficiario,
  getReport,
} from "../../../../api/Orion/beneficiario";
import { fetchUploadFile } from "../../../../api/Common/file";
import { addHash } from "../../../../api/Common/report";
import {
  FiltersOrionBeneficiaro,
  getPermissionsSecondary,
  ModalBasic,
  PaginationTable,
  Reports,
  MessageBeforeList,
} from "../../../../components/Common";
import { useHistory } from "react-router-dom";
import { ListadoBeneficiarios } from "../../../../components/Admin/Orion";
import { HeaderPage } from "../../../../components/Admin";
import { toast } from "react-toastify";
import "./AbmAdmin.scss";
import { getPermissions } from "../../../../components/Common";
import { useAuth, useNotification } from "../../../../hooks";
import { animateScroll as scroll } from "react-scroll";

function ModalBasicExcel(props) {
  const [loadingExcel, setLoadingExcel] = useState(false);
  const [title, setTitle] = useState("Adjuntar Excel");
  const {
    show,
    size,
    children,
    onClose,
    onConfirm,
    dataModal,
    buttonSi,
    buttonNo,
  } = props;
  const onConfirmExcel = async (data) => {
    setLoadingExcel(true);
    if (props.file === "") {
      toast.error("Adjunte un excel para poder guardar");
      setLoadingExcel(false);
    } else {
      try {
        let response = await addExcelBeneficiario(props.file);

        const objetoJSON = JSON.stringify(response);
        const objetoParseado = JSON.parse(objetoJSON);

        if (objetoParseado.error !== undefined) {
          toast.error(
            `Error en la fila: ${
              objetoParseado.fila
            }. Descripción : ${JSON.stringify(objetoParseado.error)}`
          );
        } else {
          toast.success(
            `Se agregaron: ${objetoParseado.data.nuevos} beneficiarios. Se actualizaron: ${objetoParseado.data.update} beneficiarios. Se dieron de baja: ${objetoParseado.data.baja} beneficiarios.`
          );
        }
        onConfirm();
      } catch (error) {
        toast.error("Error al procesar el archivo Excel");
      } finally {
        setLoadingExcel(false);
      }
    }
  };
  return (
    <Modal className="modal-basic" open={show} size={size}>
      {loadingExcel ? (
        <Modal.Header>Cargando beneficiarios ...</Modal.Header>
      ) : (
        <>
          {title && <Modal.Header>{title}</Modal.Header>}
          <Modal.Content>{children}</Modal.Content>
          <Modal.Actions>
            <Button color="red" inverted onClick={onClose}>
              <Icon name="remove" /> {buttonNo !== undefined ? buttonNo : "No"}
            </Button>
            <Button
              color={loadingExcel ? "grey" : "green"}
              disabled={loadingExcel}
              inverted={!loadingExcel}
              onClick={() => onConfirmExcel(dataModal)}
            >
              {loadingExcel ? (
                <>
                  <Loader
                    active
                    size="mini"
                    inline={true}
                    style={{ marginRight: "12px" }}
                  />{" "}
                  Cargando...
                </>
              ) : (
                <>
                  <Icon name="checkmark" />
                  {buttonSi !== undefined ? buttonSi : "Si"}
                </>
              )}
            </Button>
          </Modal.Actions>
        </>
      )}
    </Modal>
  );
}



export function BeneficiarioOrionList() {
  const { auth } = useAuth();
  const { startInterval } = useNotification();
  const [beneficiarios, setBeneficiarios] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showModalDelete, setShowModalDelete] = useState(false);
  const [showModalImportExcel, setShowModalImportExcel] = useState(false);
  const [titleModal, setTitleModal] = useState(null);
  const [buttonNo, setButtonNo] = useState("");
  const [buttonSi, setButtonSi] = useState("");
  const [dataModal, setDataModal] = useState(null);
  const [contentModal, setContentModal] = useState(null);
  const [file, setFile] = useState("");
  const [refetch, setRefetch] = useState(false);
  const [activePage, setActivePage] = useState(1);
  const [countPage, setCountPage] = useState(1);
  const [showModalFilters, setShowModalFilters] = useState(false);
  const [filtersActive, setFiltersActive] = useState("");
  const [searchActive, setSearchActive] = useState("");
  const [closeMessage, setCloseMessage] = useState(false);

  const limitPagination = 10;
  const history = useHistory();
  const fetchBeneficiarios = async (request = null) => {
    const beneficiarios = await getBeneficiarios(request);

    setBeneficiarios(beneficiarios.results);
    setCountPage(beneficiarios.count);
    setLoading(false);
  };
  useEffect(() => {
    scroll.scrollToTop();

    let filtrosExistentes = sessionStorage.getItem("orion_beneficiarios_filters");
    let searchExistentes = sessionStorage.getItem("orion_beneficiarios_search");
    if (searchExistentes) {
      setSearchActive(searchExistentes);
      setFiltersActive(filtrosExistentes || "");
      fetchBeneficiarios(
        filtrosExistentes !== ""
          ? `search=${searchExistentes}&${filtrosExistentes}`
          : `search=${searchExistentes}`
      );
    } else {
      setFiltersActive(filtrosExistentes || "");
      fetchBeneficiarios(
        filtrosExistentes !== ""
          ? `page=1&${filtrosExistentes}`
          : "page=1"
      );
    }
  }, [refetch]);

  const onRefetch = () => setRefetch((prev) => !prev);
  const openCloseModalDelete = () => {
    setShowModalDelete((prev) => !prev);
  };
  const openCloseModalImportExcel = () => {
    setShowModalImportExcel((prev) => !prev);
  };
  const onDeleteBeneficiario = async (beneficiario) => {
    setContentModal(
      <p>
        Desea eliminar el beneficiario {beneficiario.asegurado_nombre}{" "}
        {beneficiario.asegurado_apellido} ?
      </p>
    );
    setTitleModal("Eliminar beneficiario");
    setShowModalDelete(true);
    setDataModal(beneficiario.id);
    setButtonSi("Si");
    setButtonNo("No");
  };
  const openConfirmModalDelete = async (id) => {
    try {
      let response = await deleteBeneficiario(id);

      toast.success(response.data);
      setShowModalDelete(false);
      onRefetch();
    } catch (error) {
      console.error("Error en BeneficiarioOrionList (delete):", error);
    }
  };
  const openConfirmModalImportExcel = () => {
    try {
      setShowModalImportExcel(false);
    } catch (error) {
      console.error("Error en BeneficiarioOrionList (import):", error);
    }
  };

  const handleUploadFile = async (event) => {
    //!
    setLoading(true);
    var file = event.target.files[0];
    const formData = new FormData();
    if (file) {
      formData.append("file", file);
      const response_pdf_upload_factura = await fetchUploadFile(formData);
      if (response_pdf_upload_factura.data !== undefined) {
        setFile(response_pdf_upload_factura.data[0]);
        setLoading(false);
      } else {
        toast.error(`Error: ${JSON.stringify(response_pdf_upload_factura)}`);
      }
    }
  };
  const importBeneficiarios = async () => {
    setContentModal(
      <input
        className="input"
        accept="'image/jpg','image/jpeg', 'image/png', 'image/bmp', 'application/*'"
        type="file"
        onChange={handleUploadFile}
      />
    );
    setTitleModal("Adjuntar documento");
    setShowModalImportExcel(true);
    setDataModal("");
    setButtonSi("Guardar");
    setButtonNo("Cancelar");
  };
  const crearBeneficiario = (id) => {
    history.push(`/admin/beneficiario_orion/crear`);
  };

  const onEditBeneficiario = (beneficiario) => {
    history.push(`/admin/beneficiario_orion/edit/id/${beneficiario.id}`);
  };
  const onShowBeneficiario = (beneficiario) => {
    history.push(`/admin/beneficiario_orion/show/id/${beneficiario.id}`);
  };

  const onSearch = (e) => {
    const value = e.target.value;
    setSearchActive(value);
    sessionStorage.setItem("orion_beneficiarios_search", value);
    fetchBeneficiarios(
      filtersActive !== "" ? `search=${value}&${filtersActive}` : `search=${value}`
    );
  };

  const onReports = async () => {
    let queryParams = filtersActive || "";
    if (searchActive !== "") {
      queryParams = `search=${searchActive}` + (queryParams ? `&${queryParams}` : "");
    }
    let response = await getReport(queryParams);
    if (!response) {
      toast.error("Error al solicitar el reporte");
    } else {
      setCloseMessage(true);
      addHash(response.hash);
      startInterval();
    }
  };
  const onChange = (e, pageInfo) => {
    let filtrosExistentes = sessionStorage.getItem('orion_beneficiarios_filters') || "";
    let request = `page=${pageInfo.activePage.toString()}`;
    if (searchActive !== "") request += `&search=${searchActive}`;
    if (filtrosExistentes) request += `&${filtrosExistentes}`;
    fetchBeneficiarios(request);

    setActivePage(pageInfo.activePage);
  };

  const openConfirmModalFilters = (formData)=>{
    let respuesta_final = []
    let convenio_filter =""
    if(formData.aseguradora !== undefined && formData.aseguradora.length > 0){
      convenio_filter = `aseguradora=${formData.aseguradora.join(",")}`
      respuesta_final.push(convenio_filter)
    }
    fetchBeneficiarios(respuesta_final.join('&'))
    sessionStorage.setItem('orion_beneficiarios_filters',respuesta_final.join('&'))
    setFiltersActive(respuesta_final.join('&'))
    setShowModalFilters((prev)=>!prev)
    setLoading(true)

  }

  const openClearFilters = () =>{
    fetchBeneficiarios()
    setFiltersActive("")
    sessionStorage.removeItem('orion_beneficiarios_filters')
    setShowModalFilters((prev)=>!prev)
    setLoading(true)
    onRefetch()
  }

  const BotonFiltros = () =>{
    return(getPermissionsSecondary("segment_filters",auth,'filters','lizen') ? (
        <Popup
            content='Ver filtros'
            trigger={
              <Button
                  onClick={() => setShowModalFilters(true)}
                  icon={
                    <Icon
                        name='filter'
                        className='color_search'
                        inverted
                        circular />
                  }
                  inverted
            /> }/>
    ):(<Grid.Column computer={2} mobile={16} tablet={8}  ></Grid.Column>))

  }

  return (
    <div>
      <HeaderPage
        title="Beneficiarios"
        btnTitle="Agregar beneficiario"
        btnClick={crearBeneficiario}
        permitionName="add_beneficiario"
      />
      <Grid as={Segment} className="segment_search">
        <Grid.Row>
          <Grid.Column computer={3} mobile={16} tablet={16}>
            <Input
              fluid
              icon={
                <Icon
                  name="search"
                  className="color_search"
                  inverted
                  circular
                />
              }
              className="input_search"
              inverted
              placeholder="Buscar..."
              value={searchActive}
              onChange={onSearch}
            />
          </Grid.Column>
          <Grid.Column computer={2} mobile={8} tablet={8} style={{ bottom: "5px" }}>
            <BotonFiltros />
            {getPermissions("generate_report", auth) && (
              <Reports confirmReports={onReports} />
            )}
          </Grid.Column>
          <Grid.Column computer={7} mobile={16} tablet={16}></Grid.Column>
          <br></br>
          <Grid.Column computer={2} mobile={16} tablet={16}>
            {getPermissions("add_beneficiario", auth) && (
              <Button circular basic positive onClick={crearBeneficiario}>
                Agregar beneficiario
              </Button>
            )}
          </Grid.Column>
          <Grid.Column computer={2} mobile={16} tablet={16}>
            {getPermissions("view_beneficiario", auth) && (
              <Button circular basic positive onClick={importBeneficiarios}>
                Importar beneficiarios
              </Button>
            )}
          </Grid.Column>
        </Grid.Row>
      </Grid>

      <Grid>
        <Grid.Row>
          <Grid.Column computer={16}></Grid.Column>
        </Grid.Row>
      </Grid>

      {loading ? (
        <Loader active inline="centered">
          Cargando...
        </Loader>
      ) : (
        <>
          <MessageBeforeList
            text={{
              value: "Cuando finalice la descarga, se visualizará en la campana de notificaciones",
            }}
            closeMessage={closeMessage}
            onCloseMessage={() => setCloseMessage(false)}
            warning={true}
          />
          <ListadoBeneficiarios
            beneficiarios={beneficiarios}
            onDeleteBeneficiario={onDeleteBeneficiario}
            onEditBeneficiario={onEditBeneficiario}
            onShowBeneficiario={onShowBeneficiario}
            countPage={countPage}
            pagination={
              <PaginationTable
                beneficiarios={beneficiarios}
                onChange={onChange}
                activePage={activePage}
                countPage={countPage}
                limitPagination={limitPagination}
              />
            }
          />
        </>
      )}

      <ModalBasic
        show={showModalDelete}
        size="small"
        title={titleModal}
        children={contentModal}
        onClose={openCloseModalDelete}
        onConfirm={openConfirmModalDelete}
        dataModal={dataModal}
        buttonNo={buttonNo}
        buttonSi={buttonSi}
        loading={loading}
      />
      <ModalBasicExcel
        show={showModalImportExcel}
        size="small"
        title={titleModal}
        children={contentModal}
        onClose={openCloseModalImportExcel}
        onConfirm={openConfirmModalImportExcel}
        dataModal={dataModal}
        buttonNo={buttonNo}
        buttonSi={buttonSi}
        file={file}
      />
      <FiltersOrionBeneficiaro
        show={showModalFilters}
        onClose={() => setShowModalFilters(false)}
        onConfirm={openConfirmModalFilters}
        onClear={openClearFilters}
        auth={auth}
        type={"orion"}
      />
    </div>
  );
}
